<template>
  <div :class="$style.wrapper">
    <PageContentImage
      :class="imageClass || 'w-100'"
      :src="image"
    />
    <PageContent
      :class="contentClass || 'w-100'"
      :title="content.title"
      :paragraphs="content.paragraphs"
      :title-class="content.titleClass"
      :paragraph-class="content.paragraphClass"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import PageContentImage from '../components/PageContentImage.ts.vue';
import PageContent, { Content } from '../components/PageContent.ts.vue';
import { StyleClass } from '../types/StyleClass';

export interface PageCardContentProps {
  image: string;
  content: Content;
  imageClass?: StyleClass;
  contentClass?: StyleClass;
}

export default Vue.extend({
  components: {
    PageContentImage,
    PageContent,
  },
  props: {
    image: {
      type: String as PropType<PageCardContentProps['image']>,
      required: true,
    },
    content: {
      type: Object as PropType<PageCardContentProps['content']>,
      required: true,
    },
    imageClass: {
      type: [String, Array, Object] as PropType<PageCardContentProps['imageClass']>,
      default: undefined,
    },
    contentClass: {
      type: [String, Array, Object] as PropType<PageCardContentProps['contentClass']>,
      default: undefined,
    },
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';
@import '../styles/variables';

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
</style>
